import moment from 'moment-timezone';

// Hitch dispatch runs entirely in Texas, and every trip time in the UI is rendered
// in its origin city's timezone (see TripsTable / TripItinerary). So "a day of
// trips" has to mean a day in Central — never a day on whoever's browser clock
// happens to have the dashboard open.
//
// Ops staff work from several timezones. Defining the daily window with plain
// `moment(date).startOf('day')` used the *viewer's* local midnight, which slid the
// window by their UTC offset and, once their local clock passed midnight, defaulted
// the page to tomorrow's date outright. The result was a trips page that silently
// dropped most of the day's active trips.
export const OPS_TIMEZONE = 'America/Chicago';

// The ops calendar date right now, as the YYYY-MM-DD string the date picker holds.
export const todayInOpsTimezone = () => moment().tz(OPS_TIMEZONE).format('YYYY-MM-DD');

// The absolute instants bounding an ops calendar date, for range queries.
export const opsDayRange = (date) => {
  const day = moment.tz(date, 'YYYY-MM-DD', OPS_TIMEZONE).startOf('day');
  return {
    start: day.toISOString(),
    end: day.clone().endOf('day').toISOString(),
  };
};
